import React from "react";

interface ActionButtonProps {
  onClick: () => void;
}
export const ActionButton: React.FC<ActionButtonProps> = React.memo(
  ({ onClick }) => {
    return (
      <group onPointerDown={onClick}>
        <mesh>
          <sphereBufferGeometry attach="geometry" args={[5, 32, 32]} />
          <meshBasicMaterial
            attach="material"
            color="blue"
            transparent
            opacity={0}
            depthWrite={false}
          />
        </mesh>
      </group>
    );
  }
);
